import { ITypedAPITarget, IAPITarget } from "network/NetworkStapler";
import {
    IConsentsResponse
} from "types/usermanagement";
import auth from "stores/AuthStore";
import { config } from "config";

export function getConsents(): ITypedAPITarget<IConsentsResponse[]> {
    return {
        url: "api/usermanagement/consents",
        headers: {
            "Accept": "application/json"
        },
        method: "GET",
        parse: json => json as IConsentsResponse[]
    };
}

export function deleteConsent(consentId: string): IAPITarget {
    return {
        url: "api/usermanagement/consents/" + consentId,
        headers: {
            "Accept": "application/json"
        },
        method: "DELETE"
    };
}

export function revokeToken(): IAPITarget {
    const params = { token: auth.accessToken };
    const searchParams = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return {
        url: "sts/oauth/revoke",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "POST",
        body: searchParams
    };
}

export function logout(): IAPITarget {
    const params = { token: auth.accessToken };
    const searchParams = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + "=" + encodeURIComponent(params[key]);
    }).join("&");

    return {
        url: "sts/oauth/logout",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded"
        },
        method: "POST",
        body: searchParams
    };
}


// WEBPACK FOOTER //
// ./src/network/UserManagementAPI.ts